import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { PAN_NUMBER, GST_REGEX } from '../../../../../utils/validations';
import { setUser } from '../../../../../app/store/slices/auth/authSlice';
import { updateKycDetails } from '../../../../../app/store/slices/user/user';
import { successToastTopRight } from '../../../../../utils/toasts/toasts';

export default function useInvoiceInfo() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    const [loading, setLoading] = useState(false);

    const initialValues = {
        panNumber: user?.verification?.pan_number || '',
        gstNumber: user?.verification?.gst_number || '',
        isGstRegistered: (user?.verification?.gst_number === null || user?.verification?.gst_number === '') ? false : true,
        isEditable: false
    };

    const validationSchema = Yup.object({
        panNumber: Yup.string()
            .matches(PAN_NUMBER, 'Invalid PAN Number')
            .required('PAN Number is required'),
        isGstRegistered: Yup.boolean().required('GST Registration status is required'),
        gstNumber: Yup.string().when('isGstRegistered', {
            is: true,
            then: (schema) =>
                schema.matches(GST_REGEX, 'Invalid GST Number').required('GST Number is required'),
            otherwise: (schema) => schema.notRequired()
        })
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            try {
                setLoading(true);

                const payload = {
                    user_id: user?.id,
                    pan_number: values.panNumber,
                    gst_number: values.isGstRegistered ? values.gstNumber : null
                };

                const response = await dispatch(
                    updateKycDetails({
                        id: user?.verification?.id,
                        payload
                    })
                ).unwrap();

                dispatch(setUser({
                    verification: response?.data
                }))

                successToastTopRight('Invoice details updated successfully');

                formik.setFieldValue('isEditable', false);
            } catch (error) {
                console.log('Error updating invoice info:', error);
                formik.setFieldValue('isEditable', true, false);
            } finally {
                setLoading(false);
            }
        }
    });

    return {
        formik,
        loading
    };
}

// 15 Digits => GST Number
// 10 Digits => PAN Number